import React, { useEffect, useMemo } from 'react';
import { getAchievements, getAchievementsProgress, getAchievementsProgressError } from '../achievementsSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { getAchievementsProgressAction } from '../achievementsReducer';
import AchievementProgressCarousel from './AchievementProgressCarousel';
import { ACHIEVEMENT_STATUS } from '../achievementsConstants';

export default function AchievementProgress() {
    const dispatch = useDispatch();
    const achievementsAll = useSelector(getAchievements);
    const achievementsProgress = useSelector(getAchievementsProgress);
    const achievementsProgressError = useSelector(getAchievementsProgressError);
    const achievementsProgressUnfinished = useMemo(
        () => achievementsProgress.filter(({ status }) => status !== ACHIEVEMENT_STATUS.COMPLETED),
        [achievementsProgress],
    );

    useEffect(() => {
        dispatch(getAchievementsProgressAction());
    }, [achievementsAll, dispatch]);

    if (achievementsProgressError) return null;

    if (!achievementsProgressUnfinished.length) return null;

    return <AchievementProgressCarousel achievements={achievementsProgressUnfinished}/>;
}
